<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  padding: 0 20px 20px 280px;
  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 10px solid #3399ff;
    font-size: 16px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    color: #666666;
    font-weight: 700;
    padding-left: 15px;
  }
  .elmargin{
    margin-bottom: 21px;
  }
}
.tree_box {
  width: 100%;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
  p {
    padding: 0;
    margin: 0;
    color: #666;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
  }
}
.el-table{
  width:99.9% !important;
}
</style>
<template>
  <div>
    <div class="tree_box">
      <div style="display: flex; justify-content: space-between; font-size: 18px">
        <div style="cursor: pointer;" @click="onRootNodeClick">组织结构</div>
      </div>
      <el-tree
              :data="data"
              node-key="id"
              :props="defaultProps"
              @node-click="handleNodeClick"
              :expand-on-click-node="false"
              :default-expand-all="false"
              style="margin-top: 15px; max-height: 700px; overflow-y: scroll; overflow-x: hidden"
      >
      </el-tree>
    </div>
  </div>
</template>

<script>
import index from "@/components/mixins/index";
import {getFuncTree,getFunc} from "@/views/serviceapp/systemManage/organizationManage/api/index"
import request from '@/utils/apiRequest'

export default {
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name",
      },
      selectedNode: null,
      data: []
    };
  },
  methods: {
    handleClick(index, row) {
      console.log(index, row);
    },
    getTree() {
      getFuncTree()
        .then((res) => {
          this.data = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
        });
    },
    handleNodeClick(node){
      this.selectedNode = node
      this.$emit("onNodeClick", node)
    },
    onRootNodeClick() {
      this.selectedNode = null
      this.$emit("onNodeClick", {
        name: '组织架构',
        id: ''
      })
    }
  },
  components: {
  },
  mounted(){
    this.getTree();
  }
};
</script>

